import typia from "typia";
import { validate as v } from "CoreUtils";
import * as v7 from "./index";

// ============================================================================
// v7 Schema Validators
// Following the repository pattern of using typia with CoreUtils validators
// ============================================================================

export const Layout = {
  validator: new v.Validator(typia.createValidate<v7.layout.Layout>()),
};

export const Schematic = {
  validator: new v.Validator(typia.createValidate<v7.schematic.Schematic>()),
};

export const Symbol = {
  validator: new v.Validator(typia.createValidate<v7.symbol.Symbol>()),
};

export const Graphics = {
  validator: new v.Validator(typia.createValidate<v7.core.GraphicsContent>()),
};

export const Content = {
  validator: new v.Validator(typia.createValidate<v7.content.Content>()),
};

export const Circuit = {
  validator: new v.Validator(typia.createValidate<v7.circuit.Circuit>()),
};

// SPICE-class simulation schema validators.
export const Sim = {
  validator: new v.Validator(typia.createValidate<v7.sim.Sim>()),
};

export const SimResult = {
  validator: new v.Validator(typia.createValidate<v7.sim.SimResult>()),
};

export const PDK = {
  validator: new v.Validator(typia.createValidate<v7.pdk.PDK>()),
};

export const Stack = {
  validator: new v.Validator(typia.createValidate<v7.pdk.Stack>()),
};

export const MetalLayer = {
  validator: new v.Validator(typia.createValidate<v7.metal.MetalLayer>()),
};

export const ViaDefinition = {
  validator: new v.Validator(typia.createValidate<v7.metal.ViaDefinition>()),
};

export const PDKLayer = {
  validator: new v.Validator(typia.createValidate<v7.pdk.PDKLayer>()),
};

export const PDKLayerPurpose = {
  validator: new v.Validator(typia.createValidate<v7.pdk.PDKLayerPurpose>()),
};

export const Exports = {
  validator: new v.Validator(typia.createValidate<v7.pdk.Exports>()),
};

export const SelectionBbox = {
  validator: new v.Validator(typia.createValidate<v7.core.SelectionBbox>()),
};

// Parasitic extraction validators
export const PersistedParasitics = {
  validator: new v.Validator(
    typia.createValidate<v7.parasitics.PersistedParasitics>()
  ),
};

export const PersistedSegment = {
  validator: new v.Validator(
    typia.createValidate<v7.parasitics.PersistedSegment>()
  ),
};

export const PersistedNetTotals = {
  validator: new v.Validator(
    typia.createValidate<v7.parasitics.PersistedNetTotals>()
  ),
};
